import { ReactNode } from "react";

import { classNames } from "helpers/commonHelpers";

interface FreightDocumentRowProps {
  label: ReactNode;
  required?: boolean;
  children: ReactNode;
}

export default function FreightDocumentRow({ label, required, children }: FreightDocumentRowProps) {
  return (
    <div className="upload-freight-docs__row">
      <div
        className={classNames("upload-freight-docs__label", {
          "upload-freight-docs__label--required": required,
        })}
      >
        {label}
      </div>

      {children}
    </div>
  );
}
